import { QueryClient, QueryClientProvider as TanstackQueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ReactNode } from "react";

interface QueryClientProviderProps {
    client: QueryClient;
    children: ReactNode;
}

export const QueryClientProvider = ({ children, client }: QueryClientProviderProps) => (
    <TanstackQueryClientProvider client={client}>
        {children}
        <ReactQueryDevtools initialIsOpen={false} />
    </TanstackQueryClientProvider>
);
